























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import DataCollectionPolicy from '@/components/DataCollectionPolicy.vue'
import gaCustomLinks from '@/utils/gaCustomLinks'

@Component({
  components: {
    DataCollectionPolicy,
  },
})
export default class About extends Vue {
  @Getter('currentTheme') private getterTheme!: Theme
  @Getter('currentLang') private getterLang!: Language

  private version = `${process.env.VUE_APP_VERSION}`
  private showDataCollectionPolicyDialog = false

  get fullYear(): number {
    return new Date().getFullYear()
  }

  get mqttxLogoSrc(): string {
    if (this.getterTheme === 'light') {
      return require('@/assets/images/mqttx-dark.png')
    }
    return require('@/assets/images/mqttx-light.png')
  }

  get emqLogoSrc(): string {
    if (this.getterTheme === 'light') {
      return require('@/assets/images/emq-logo-dark.png')
    }
    return require('@/assets/images/emq-logo-light.png')
  }

  get emqWebsite(): string {
    return gaCustomLinks(this.getterLang).about.EMQ
  }

  get emqxPlatformWebsite(): string {
    return gaCustomLinks(this.getterLang).about.EMQXPlatform
  }

  get signInLink(): string {
    return gaCustomLinks(this.getterLang).about.signIn
  }

  get mqttxWebsite(): string {
    return gaCustomLinks(this.getterLang).MQTTXSite
  }

  get releasesLink(): string {
    return `${this.mqttxWebsite}/changelogs/v${this.version}`
  }

  get faqLink(): string {
    return gaCustomLinks(this.getterLang).about.faq
  }

  private goToLink(url: string) {
    const windowUrl = window.open(url)
    if (windowUrl) {
      windowUrl.opener = null
    }
  }

  private openDataCollectionPolicyDialog() {
    this.showDataCollectionPolicyDialog = true
  }
}
